import { HgSupportedLanguage } from '@smg-real-estate/domus';

import { GTMPageSubType, GTMPageType } from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';

export function trackErrorPageLoad(
  language: HgSupportedLanguage,
  subType: GTMPageSubType,
  listingId?: string,
): void {
  trackEventHarmonized('virtual_pageview', {
    h_page_type_110: GTMPageType.PAGE_NOT_FOUND,
    h_page_subtype_112: subType,
    h_content_language_116: language,
    h_listing_advertisement_id_120: listingId,
  });
}
